export const getId = (idPrefix = '', name = '') => idPrefix ? idPrefix + name : null;
export const calculateWidth = (totalPages) => `${totalPages.toString().length}em`;
export const upperCaseFirst = (str) => str[0].toUpperCase() + str.slice(1);
//# sourceMappingURL=utils.js.map